import { render, staticRenderFns } from "./UpsellBundleProduct.vue?vue&type=template&id=a8f5ff1e"
import script from "./UpsellBundleProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpsellBundleProduct.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpsellBundleProduct.vue?vue&type=style&index=0&id=a8f5ff1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports